import globalStore from "@/models/GlobalStore";

export default function base64toUInt8Array(base64: string) {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

function getPdf(pdfContent: Uint8Array): string {
  const blob = new Blob([pdfContent], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  return url;
}

export function openPdfInNewTab(pdfContent: Uint8Array) {
  if (!pdfContent) return;
  const url = getPdf(pdfContent);
  window.open(url, "_blank");
  URL.revokeObjectURL(url);
}

export function openPdfInCurrentTab(pdfContent: Uint8Array) {
  if (!pdfContent) return;
  const url = getPdf(pdfContent);
  window.open(url);
  URL.revokeObjectURL(url);
}

export function downloadFile(fileContent: Uint8Array | Blob, fileName = "undefined", fileType: string = globalStore.fileType.pdf) {
  let blob;
  if (fileContent instanceof Uint8Array) {
    blob = new Blob([fileContent], { type: fileType });
  } else if (fileContent instanceof Blob) {
    blob = fileContent;
  } else {
    return;
  }
  const url = URL.createObjectURL(blob);
  const extension = Object.keys(globalStore.fileType)
    .find(key => globalStore.fileType[key as keyof typeof globalStore.fileType] === fileType);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}.${extension}`;
  link.click();

  URL.revokeObjectURL(url);
}